/**
 * Defines the request-specific keys for CMCD (Common Media Client Data) version 2.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_REQUEST_KEYS = [
	'd',
	'dl',
	'nor',
	'ot',
	'rtp',
	'su',
] as const;
